/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-17 07:55:13
 *
 *******************************************************/
//flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Page, Layout, TextStyle, DisplayText } from '@shopify/polaris';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Progress from './progress';
import Slider from 'src/components/views/subscription/migration/slider';

type Props = {
  selectedPlan: string
};

type ComposedProps = Props & WithI18nProps;

class PlanMigration extends Component<ComposedProps> {
  render() {
    const { i18n, selectedPlan } = this.props;
    const planNameText =
      !!selectedPlan && selectedPlan.includes('plus_')
        ? 'title_t1_plan_plus'
        : 'title_t1_plan_premium';

    return (
      <div className="BC-AnotherLayout">
        <Page
          title={i18n.translate('AdminHTML.Subscription.PlanMigration.title', {
            t1_plan: i18n.translate(`AdminHTML.Subscription.PlanMigration.${planNameText}`)
          })}>
          <Layout>
            <Layout.Section>
              <DisplayText size="small">
                <span className="text-installation">
                  {i18n.translate('AdminHTML.Subscription.PlanMigration.content', {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate('AdminHTML.Subscription.PlanMigration.content_t1')}
                      </TextStyle>
                    )
                  })}
                </span>
              </DisplayText>
            </Layout.Section>

            <Progress />

            <Slider />
          </Layout>
        </Page>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan')
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(PlanMigration));
